import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'scitis-status-event-page-configuration-selected-item',
    templateUrl: './status-event-page-configuration-selected-item.component.html',
    styleUrls: ['./status-event-page-configuration-selected-item.component.scss'],
    standalone: false
})
export class StatusEventPageConfigurationSelectedItemComponent {

  @Input()
  itemId: number | undefined = undefined;

  @Input()
  details: string = '';

  @Input()
  detailsLabel: string = '';

  @Input()
  displayName: string = '';

  @Output()
  public removeItemFromSelection: EventEmitter<number | undefined> = new EventEmitter<number | undefined>();

  onRemoveItem(id: number | undefined) {
    this.removeItemFromSelection.emit(id);
  }


}
